import {
  Button,
  IconButton,
  Stack,
  Typography,
} from "@braintrust/braintrust-ui-components";
import { CloseSVGIcon } from "@braintrust/braintrust-ui-components/Icons";
import { RouterLink } from "@js/components/link";
import { ModalInstance } from "@js/components/modal";

import styles from "./styles.module.scss";

const IDV_FAILED_ARTICLE_URL =
  "https://support.usebraintrust.com/hc/en-us/articles/40107166609943-Identity-Verification-IDV";

export const IdentityVerificationUnsuccessfulModal = ({
  isAcceptOfferFlow,
}: {
  isAcceptOfferFlow?: boolean;
}) => {
  const onCloseClick = () => {
    ModalInstance.close();
  };

  const flowRelatedText = isAcceptOfferFlow
    ? "offer cannot be accepted"
    : "application won’t be submitted";

  return (
    <Stack sx={{ p: 3 }}>
      <Typography
        component="h2"
        variant="title"
        size="small"
        fontWeight={400}
        sx={{ mb: 2, maxWidth: "80%" }}
      >
        Identity verification unsuccessful
      </Typography>
      <IconButton
        aria-label="close modal"
        size="medium"
        variant="transparent"
        onClick={onCloseClick}
        sx={{
          position: "absolute",
          top: { xs: "14px", sm: "19px" },
          right: { xs: "14px", sm: "19px" },
        }}
      >
        <CloseSVGIcon />
      </IconButton>
      <Typography component="p" variant="paragraph" sx={{ mb: 3 }}>
        We weren’t able to verify your identity, so your {flowRelatedText}. If
        you believe this was a mistake, please contact support by{" "}
        <Typography
          component="a"
          variant="link"
          RouterLink={RouterLink}
          href={SETTINGS.SUPPORT_URLS.CONTACT_SUPPORT_URL}
          fontWeight={500}
          rel="noopener noreferrer"
          target="_blank"
        >
          submitting a request on our help center
        </Typography>
        .
        <br />
        <br />
        For more information, please review our{" "}
        <Typography
          component="a"
          variant="link"
          RouterLink={RouterLink}
          href={IDV_FAILED_ARTICLE_URL}
          fontWeight={500}
          rel="noopener noreferrer"
          target="_blank"
        >
          Identity Verification FAQs
        </Typography>
        .
      </Typography>
      <Stack direction="row" sx={{ justifyContent: "end" }}>
        <Button variant="primary" shape="squared" onClick={onCloseClick}>
          Close
        </Button>
      </Stack>
    </Stack>
  );
};

export const openIdentityVerificationUnsuccessfulModal = ({
  onClose,
  isAcceptOfferFlow,
}: {
  onClose: () => void;
  isAcceptOfferFlow?: boolean;
}) => {
  ModalInstance.open({
    children: (
      <IdentityVerificationUnsuccessfulModal
        isAcceptOfferFlow={isAcceptOfferFlow}
      />
    ),
    padding: false,
    className: styles.modal,
    closeButton: false,
    onClose,
  });
};
